const Util = {
    // mapUrl: 'https://map1.szyac.cn',
    // searchURL: 'http://192.168.2.36:80',
    // operateURL: 'http://192.168.2.39:9066/',
    // operateURL: 'https://pb-dev.d.yianiot.cn/',// 测试环境
    // operateURL: 'https://pb.d.yianiot.cn/', // 正式环境
    ApiUrl: 'https://mp.cxcamp.cn/',
    // parkingURL: 'http://192.168.5.51:1301/',

    getCookie: (name) => {
        let reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)')
        let arr = document.cookie.match(reg)
        if (arr) {
            return unescape(arr[2])
        } else {
            return null
        }
    },
    // 强复制
    superCopy: (obj) => {
        return JSON.parse(JSON.stringify(obj))
    },
    delCookie: (name) => {
        let exp = new Date()
        exp.setTime(exp.getTime() - 1)
        let cval = Util.getCookie(name)
        if (cval != null) {
            document.cookie = name + '=' + cval + ';expires=' + exp.toGMTString() + '; path=/'
        }
    },
    setCookie: (name, value, h) => {
        let exp = new Date()
        exp.setTime(exp.getTime() + h * 60 * 60 * 1000)
        document.cookie = name + '=' + value + ';expires=' + exp.toGMTString() + '; path=/'
    },
    changeTwoDecimal(x) {
        var f_x = parseFloat(x);
        if (isNaN(f_x)) {
            return '';
        }
        f_x = Math.round(x * 100) / 100;
        var s_x = f_x.toString();
        var pos_decimal = s_x.indexOf('.');
        if (pos_decimal < 0) {
            pos_decimal = s_x.length;
            s_x += '.';
        }
        while (s_x.length <= pos_decimal + 2) {
            s_x += '0';
        }
        return s_x;
    },
    // 数值只允许输入到小数点后两位
    inputChangeTwoDecimal(val) {
        let num = "";
        if (
            val.split(".").length == 2 &&
            val.split(".")[1] &&
            val.split(".")[1].length > 2
        ) {
            num = `${val.split(".")[0]}.${val.split(".")[1].substring(0, 2)}`;
        } else if (val.split(".").length > 2) {
            num = parseFloat(`${val.split(".")[0]}.${val.split(".")[1]}`);
        } else {
            num = val;
        }
        return num
    },
    // 数值只允许输入到小数点后四位
    inputChangeFourDecimal(val) {
        let num = "";
        if (
            val.split(".").length == 2 &&
            val.split(".")[1] &&
            val.split(".")[1].length > 2
        ) {
            if(val.split(".")[0]){
                num = `${val.split(".")[0]}.${val.split(".")[1].substring(0, 4)}`;
            }else{
                num = `0.${val.split(".")[1].substring(0, 4)}`;
            }
        } else if (val.split(".").length > 2) {
            num = parseFloat(`${val.split(".")[0]}.${val.split(".")[1]}`);
        } else {
            num = val;
        }
        return num
    },
    // 数值只允许输入整数
    inputChangeNoDecimal(val) {
        let num = "";
        if (val && val.split(".").length == 2 ) {
            num = `${val.split(".")[0]}`;
        } else {
            num = val;
        }
        return num
    },
    // 手机格式不对为true
    checkPhone(val) {
        if (!(/^((13[0-9])|(14[0-9])|(15([0-9]))|(16[0-9])|(17[0-9])|(18[0-9])|(19[0-9]))\d{8}$/.test(val))) {
            return true
        }
    },
    // 日期显示到秒
    formatTimeG(date) {
        var arr = date.split(/[- : .]/);
        return [arr[0], arr[1], arr[2]].join('-') + ' ' + [arr[3], arr[4], arr[5]].join(':')
    },
    // 检测是否是数字,不是数字返回true
    testNumber(val){
      let reg = /^[0-9]+\.?[0-9]*$/
      if (!reg.test(val)) {
        return true
      }
    },
    // 监听数据输入数字
    testNumberFn(val,fnName){
      let reg = /^[0-9]+\.?[0-9]*$/
      let d= ""
      if (!reg.test(val)) {
        d = "";
      } else {
        if(fnName=="inputChangeTwoDecimal"){
          d=this.inputChangeTwoDecimal(val);
        }
        if(fnName=="inputChangeNoDecimal"){
          d=this.inputChangeNoDecimal(val);
        }
        if(fnName=="inputChangeFourDecimal"){
          d=this.inputChangeFourDecimal(val);
        }
      }
      return d
    },
    // 不能输入数字
    isText(val){
      let reg = /[\d]/g
      let d= ""
      if (reg.test(val)) {
        d = "";
      }else{
        d=val
      }
      return d
    },
    // 只能输入数字
    isNumber(val){
      let reg = /^[0-9]+\.?[0-9]*$/
      let d= ""
      if (!reg.test(val)) {
        d = "";
      } else {
       d=val
      }
      return d
    },
    getUrlParam(name) {
        return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null
    }
  }

export default Util